module.exports = __webpack_public_path__ + "img/racao-para-animais.20621887.png";